export const AiAssistantLocalization = {
	buttonTexts: {
		rus: {
			context1: 'Ответь на основе контекста',
			context2: 'Подготовь саммари файла',
			context3: 'Создай новый документ',
			context4: 'Создай новый документ из шаблона',
			context5: 'Найди судебную практику для кейса',
			context6: 'Подготовь саммари веб-сайта',
			context7: 'Переведи документ на другой язык',
			context8: 'Проверь грамматику',
			context9: 'Договор аренды',
			context10: 'Счет',
			context11: 'Фриланс-контракт',
			context12: 'Договор о неразглашении'
		},
		eng: {
			context1: 'Answer based on context',
			context2: 'Prepare a file summary',
			context3: 'Create a new document',
			context4: 'Create a new document from template',
			context5: 'Find case law for the case',
			context6: 'Prepare website summary',
			context7: 'Translate document to another language',
			context8: 'Check grammar',
			context9: 'Lease agreement',
			context10: 'Invoice',
			context11: 'Freelance contract',
			context12: 'Non-disclosure agreement',
		},
		esp: {
			context1: 'Responder basado en el contexto',
			context2: 'Preparar resumen del documento',
			context3: 'Crear un nuevo documento',
			context4: 'Crear un nuevo documento a partir de una plantilla',
			context5: 'Encontrar jurisprudencia para el caso',
			context6: 'Preparar resumen del sitio web',
			context7: 'Traducir documento a otro idioma',
			context8: 'Revisar gramática',
			context9: 'Contrato de arrendamiento',
			context10: 'Factura',
			context11: 'Contrato freelance',
			context12: 'Acuerdo de confidencialidad',
		},
		deu: {
			context1: 'Antwort basierend auf Kontext',
			context2: 'Dokumentzusammenfassung vorbereiten',
			context3: 'Neues Dokument erstellen',
			context4: 'Neues Dokument aus Vorlage erstellen',
			context5: 'Rechtsprechung für den Fall finden',
			context6: 'Webseiten-Zusammenfassung vorbereiten',
			context7: 'Dokument in eine andere Sprache übersetzen',
			context8: 'Grammatik überprüfen',
			context9: 'Mietvertrag',
			context10: 'Rechnung',
			context11: 'Freelance-Vertrag',
			context12: 'Geheimhaltungsvereinbarung',
		},
		fra: {
			context1: 'Répondre en fonction du contexte',
			context2: 'Préparer le résumé du document',
			context3: 'Créer un nouveau document',
			context4: "Créer un nouveau document à partir d'un modèle",
			context5: 'Trouver la jurisprudence pour le cas',
			context6: 'Préparer le résumé du site web',
			context7: 'Traduire le document dans une autre langue',
			context8: 'Vérifier la grammaire',
			context9: 'Contrat de location',
			context10: 'Facture',
			context11: 'Contrat freelance',
			context12: 'Accord de non-divulgation',
		},
	},
	contextMessages: {
		rus: {
			context1: 'Ответь на вопрос на основе контекста: ',
			context2: 'Подготовь саммари документа',
			context3:
				'Создай новый Договор о неразглашении в свободной форме, подписывающие стороны — Иван Петров ivan@ivan.com и Николай Сидоров nick@nick.com',
			context4: 'Создай новый документ из шаблона',
			context5: 'Найди судебную практику для кейса: ',
			context6: 'Подготовь саммари веб-сайта по ссылке: ',
			context7: 'Переведи предоставленный документ на английский язык',
			context8: 'Проверь документ на грамматические ошибки',
			context9: 'Договор аренды квартиры в свободной форме, $500 в месяц, подписывающие стороны — Иван Петров ivan@ivan.com и Николай Сидоров nick@nick.com',
			context10: 'Счёт-фактура для моей орагнизации Acme, получатель - SuperInc',
			context11: 'Фриланс-контракт в свободной форме, обязанности: разработка сайта, подписывающие стороны — Иван Петров ivan@ivan.com и Николай Сидоров nick@nick.com',
			context12: 'Договор о неразглашении в свободной форме, подписывающие стороны — Иван Петров ivan@ivan.com и Николай Сидоров nick@nick.com'
		},
		eng: {
			context1: 'Answer based on context: ',
			context2: 'Prepare document summary',
			context3:
				'Create a new non-disclosure agreement, parties — John Black john@john.com and Nick Rush nick@nick.com',
			context4: 'Create a new document from template',
			context5: 'Find case law for the case: ',
			context6: 'Prepare website summary from the link: ',
			context7: 'Translate the provided document into English',
			context8: 'Check the document for grammatical errors',
			context9: 'Lease agreement for an apartment in free form, $500 per month, parties — John Black john@john.com and Nick Rush nick@nick.com',
			context10: 'Invoice for my organization Acme, recipient - SuperInc',
			context11: 'Freelance contract in free form, duties: website development, parties — John Black john@john.com and Nick Rush nick@nick.com',
			context12: 'Non-disclosure agreement in free form, parties — John Black john@john.com and Nick Rush nick@nick.com',
		},
		esp: {
			context1: 'Responder basado en el contexto: ',
			context2: 'Preparar resumen del documento',
			context3:
				'Crear un nuevo acuerdo de confidencialidad, partes — Juan Negro juan@juan.com y Nick Rush nick@nick.com',
			context4: 'Crear un nuevo documento a partir de una plantilla',
			context5: 'Encontrar jurisprudencia para el caso: ',
			context6: 'Preparar resumen del sitio web desde el enlace: ',
			context7: 'Traducir el documento proporcionado al inglés',
			context8: 'Revisar el documento para errores gramaticales',
			context9: 'Contrato de arrendamiento de un apartamento en forma libre, $500 al mes, partes — Juan Negro juan@juan.com y Nick Rush nick@nick.com',
			context10: 'Factura para mi organización Acme, destinatario - SuperInc',
			context11: 'Contrato freelance en forma libre, deberes: desarrollo de sitios web, partes — Juan Negro juan@juan.com y Nick Rush nick@nick.com',
			context12: 'Acuerdo de confidencialidad en forma libre, partes — Juan Negro juan@juan.com y Nick Rush nick@nick.com',
		},
		deu: {
			context1: 'Antwort basierend auf Kontext: ',
			context2: 'Dokumentzusammenfassung vorbereiten',
			context3:
				'Erstellen Sie eine neue Geheimhaltungsvereinbarung, Parteien — John Schwarz john@john.com und Nick Rush nick@nick.com',
			context4: 'Neues Dokument aus Vorlage erstellen',
			context5: 'Rechtsprechung für den Fall finden: ',
			context6: 'Webseiten-Zusammenfassung vom Link vorbereiten: ',
			context7: 'Übersetzen Sie das bereitgestellte Dokument ins Englische',
			context8: 'Überprüfen Sie das Dokument auf grammatikalische Fehler',
			context9: 'Mietvertrag für eine Wohnung in freier Form, $500 pro Monat, Parteien — John Schwarz john@john.com und Nick Rush nick@nick.com',
			context10: 'Rechnung für meine Organisation Acme, Empfänger - SuperInc',
			context11: 'Freelance-Vertrag in freier Form, Pflichten: Webentwicklung, Parteien — John Schwarz john@john.com und Nick Rush nick@nick.com',
			context12: 'Geheimhaltungsvereinbarung in freier Form, Parteien — John Schwarz john@john.com und Nick Rush nick@nick.com',
		},
		fra: {
			context1: 'Répondre en fonction du contexte: ',
			context2: 'Préparer le résumé du document',
			context3:
				'Créer un nouvel accord de non-divulgation, parties — John Noir john@john.com et Nick Rush nick@nick.com',
			context4: "Créer un nouveau document à partir d'un modèle",
			context5: 'Trouver la jurisprudence pour le cas: ',
			context6: 'Préparer le résumé du site web à partir du lien: ',
			context7: 'Traduire le document fourni en anglais',
			context8: 'Vérifier le document pour les erreurs grammaticales',
			context9: 'Contrat de location d\'un appartement en forme libre, 500 $ par mois, parties — John Noir john@john.com et Nick Rush nick@nick.com',
			context10: 'Facture pour mon organisation Acme, destinataire - SuperInc',
			context11: 'Contrat freelance en forme libre, devoirs : développement de sites Web, parties — John Noir john@john.com et Nick Rush nick@nick.com',
			context12: 'Accord de non-divulgation en forme libre, parties — John Noir john@john.com et Nick Rush nick@nick.com',
		},
	},
	uiText: {
		rus: {
			title: 'ИИ ассистент',
			subtitle: 'Спрашивай, модифицируй, проверяй с ИИ.',
			context: 'Выбрать контекст',
			attach: 'Прикрепить файлы',
			newChat: 'Новый чат',
			rag: 'Загрузить файлы для добавления собственного контекста',
			contracts: 'Открыть контракты',
			templates: 'Открыть шаблоны',
			language: 'Язык ассистента',
			openDoc: 'Открыть документ',
			infoStartWith: 'Начните с',
			infoContext: 'Добавьте контекст',
			messageAI: 'Напишите ассистенту...',
			infoContextHelp:
				'Контекст — это долговременная память вашего ассистента. Добавьте сюда ваши часто используемые данные, в этом случае ассистент сможет отвечать на их основе.',
			basedOnText: 'На снове нашего общения, создай новый документ',
			model: 'LLM модель',
			contextHelp: 'Ваши документы и контексты появятся здесь'
		},
		eng: {
			title: 'AI assistant',
			subtitle: 'Chat, modify, assess and more.',
			context: 'Select context',
			attach: 'Attach files',
			newChat: 'New chat',
			rag: 'Upload files to add your own context',
			contracts: 'Open contracts',
			templates: 'Open templates',
			language: 'Assistant language',
			openDoc: 'Open document',
			infoStartWith: 'Get started with',
			infoContext: 'Add context',
			messageAI: 'Message assistant...',
			infoContextHelp:
				"Context is your assistant's long-term memory. Add your frequently used data here, so the assistant can respond based on it.",
			basedOnText: 'Based on our conversation, create a new document',
			model: 'LLM model',
			contextHelp: 'Your documents and contexts will appear here'
		},
		esp: {
			title: 'Asistente de IA',
			subtitle: 'Crear, modificar, evaluar y más.',
			context: 'Seleccionar contexto',
			attach: 'Adjuntar archivos',
			newChat: 'Nuevo chat',
			rag: 'Subir archivos para agregar tu propio contexto',
			contracts: 'Abrir contratos',
			templates: 'Abrir plantillas',
			language: 'Idioma del asistente',
			openDoc: 'Abrir documento',
			infoStartWith: 'Comienza con',
			infoContext: 'Añadir contexto',
			messageAI: 'Mensaje al asistente...',
			infoContextHelp:
				'El contexto es la memoria a largo plazo de tu asistente. Añade aquí tus datos de uso frecuente para que el asistente pueda responder en base a ellos.',
			basedOnText: 'Basado en nuestra conversación, crea un nuevo documento',
			model: 'modelo LLM',
			contextHelp: 'Tus documentos y contextos aparecerán aquí'
		},
		deu: {
			title: 'KI-Assistent',
			subtitle: 'Erstellen, ändern, bewerten und mehr.',
			context: 'Kontext auswählen',
			attach: 'Dateien anhängen',
			newChat: 'Neuer Chat',
			rag: 'Dateien hochladen, um eigenen Kontext hinzuzufügen',
			contracts: 'Verträge öffnen',
			templates: 'Vorlagen öffnen',
			language: 'Assistentensprache',
			openDoc: 'Dokument öffnen',
			infoStartWith: 'Beginnen Sie mit',
			infoContext: 'Kontext hinzufügen',
			messageAI: 'Nachricht an den Assistenten...',
			infoContextHelp:
				'Kontext ist das Langzeitgedächtnis Ihres Assistenten. Fügen Sie hier Ihre häufig verwendeten Daten hinzu, damit der Assistent darauf basierend antworten kann.',
			basedOnText:
				'Basierend auf unserem Gespräch, erstelle ein neues Dokument',
			model: 'LLM Modell',
			contextHelp: 'Ihre Dokumente und Kontexte werden hier angezeigt'
		},
		fra: {
			title: 'Assistant IA',
			subtitle: 'Créer, modifier, évaluer et plus.',
			context: 'Sélectionner le contexte',
			attach: 'Joindre des fichiers',
			newChat: 'Nouveau chat',
			rag: 'Télécharger des fichiers pour ajouter votre propre contexte',
			contracts: 'Ouvrir les contrats',
			templates: 'Ouvrir les modèles',
			language: "Langue de l'assistant",
			openDoc: 'Ouvrir le document',
			infoStartWith: 'Commencez par',
			infoContext: 'Ajouter un contexte',
			messageAI: "Message à l'assistant...",
			infoContextHelp:
				"Le contexte est la mémoire à long terme de votre assistant. Ajoutez ici vos données fréquemment utilisées pour que l'assistant puisse répondre en fonction de celles-ci.",
			basedOnText:
				'Sur la base de notre conversation, créez un nouveau document',
			model: 'modèle LLM',
			contextHelp: 'Vos documents et contextes apparaîtront ici'
		},
	},
};
